import * as React from "react";
import {
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import PropTypes from "prop-types";

const Consulta = (props) => {
  const { fecha, open, onClose, onSave } = props;
  return (
    <Dialog open={open} onClose={onClose} size="xs">
      <DialogContent>
        <DialogContentText>
          {fecha && "¿Desea guardar el día " + fecha + "?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSave}>Sí</Button>
        <Button onClick={onClose}>No</Button>
      </DialogActions>
    </Dialog>
  );
};
Consulta.propTypes = {
  fecha: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};
export default Consulta;
